import { render, staticRenderFns } from "./StructureBinaryUser.vue?vue&type=template&id=2b1d16aa&scoped=true"
import script from "./StructureBinaryUser.vue?vue&type=script&lang=js"
export * from "./StructureBinaryUser.vue?vue&type=script&lang=js"
import style0 from "./StructureBinaryUser.vue?vue&type=style&index=0&id=2b1d16aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1d16aa",
  null
  
)

export default component.exports